/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { Map } from 'immutable'
import errors from '../../config/errors'

import {
  NAV_ERROR,
  NAV_SUCCESS,
  NAV_LOADING,
  TOGGLE_MENU,
  SORT_NAV,
  HIGHLIGHT_NAVBAR_SECTION
} from './action-types'

const initialState = Map({
  error: errors.basic,
  data: null,
  isLoading: null,
  isSuccess: null,
  hasError: null,
  isMenuToggled: false,
  highlightedNavbarSection: null
  // sortedNav: nav.items
})

const menuReducer = (state = initialState, action) => {
  switch (action.type) {
    case NAV_SUCCESS:
      return state
        .set('isLoading', false)
        .set('isSuccess', true)
        .set('hasError', false)
        .set('data', action.payload)
        .set('error', errors.basic)
    case NAV_ERROR:
      return state
        .set('isLoading', false)
        .set('isSuccess', false)
        .set('hasError', true)
        .set('error', action.error)
    case NAV_LOADING:
      return state
        .set('isLoading', true)
        .set('isSuccess', false)
        .set('hasError', false)
        .set('error', errors.basic)
    case SORT_NAV:
      return state.set('sortedNav', action.payload)
    case HIGHLIGHT_NAVBAR_SECTION:
      return state.set('highlightedNavbarSection', action.payload)
    case TOGGLE_MENU:
      return state.set(
        'isMenuToggled',
        action.payload && action.payload.toggle === false
          ? action.payload.toggle
          : !state.get('isMenuToggled')
      )
    default:
      return state
  }
}

export default menuReducer
